import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)




const store = new Vuex.Store({
  state: {
    //for collection setting
    collections: [
      // { label: "库存", value: "stock" },
      // { label: "钢结构", value: "tempexcel2" },
      // { label: "到货", value: "tempexcel1" },
      // { label: "临时", value: "tempexcel3" },
      // { label: "出库", value: "stock_out" },
      // { label: "进度", value: "progress_out" },
    ],
    //初始collection必须保留，避免collection为空时，发起访问，导致后台错误
    collection: { label: "none", value: "none" },//{label:"到货",value:"tempexcel1"}
    currentheader: [],
    //{ name: 'item', title: '名称' },

    clct: localStorage.getItem('CLCT') || "",
    // dbadminauthto:localStorage.getItem('DBADMINAUTHTO') ||[] ,
    searchmodel: "generalsearch",
    filter: {},
    matchrule: {},
    // matchrulestatus: true,
    //unshowfields全部为remote端指定
    unshowfields: {},//{tag:"xx",fieldsset:{shows:[],unshows:[]}}
    filtercode: {},//直接的agg filter 法则 如{$match:{receivers[req.TK.NAME]:"未确认"}}
    page: 1,
    targettxt: "",
    datainformation: { perpage: 1000, totalresults: 1000 },
    items: [],
    sortset: {},


    apiparams: {},

    //for savedsearch
    savedsearch: JSON.parse(localStorage.getItem('SAVEDSEARCH')) || [],
    history: JSON.parse(localStorage.getItem('HISTORY')) || [],
    //for fetchebyids
    fetchids: [],
    fetchidstag: "",
    //for edit vue
    edits: [],
    editsid: [],

    //for printaspdf vue
    prints: [],
    printsid: [],

    //for modifys vue
    modifys: [],
    modifysid: [],

    //for splitfield
    searchmodelthattime: "",
    splittarget: "",
    splittimemodel:{field:"",timemodel:""},
    splituniques:[],
    splitfixed: [],
    sumitem: [],
    splittimemodel:"",
    urlbeforesplit:"",

    //for qtyincrease and qtyreduce
    qtyincrease: [],
    // qtyincreasetitle: { sitestatus: "制作场日报",material:"主材喷漆",siteprogress:"progress" },
    qtyincreaseid: [],
    qtyreduce: [],
    // qtyreducetitle: { material: "主材领用", stock: "材料使用日报", equipments: "工程量申报", progress: "进度日报" },
    qtyreduceid: [],


    //for authentication 
    token: localStorage.getItem('USER_TOKEN'),
    expireTime: localStorage.getItem('EXPIRE_TIME'),
    user: localStorage.getItem('USER') || "",
    permissions: localStorage.getItem('PERMISSIONS'),
    roles: JSON.parse(localStorage.getItem('ROLES')) || [],
    community:JSON.parse(localStorage.getItem('COMMUNITY')) || [],
    userroles: JSON.parse(localStorage.getItem('USERROLES')) || [],

    //for data presentation
    dbprocessing: false,//for db data renew from server
    ifchart: true,//是否显示chart
    ifremotechart: false,//是否为远程图表数据
    chartdatanomore: true,
    chartdataxy: [],//data for time like[{x:**,y:**}]
    chartdatatime: [],
    chartdatagroup: { labels: [], datas: [] },//two groups of data for labels and data
    chartmodel: "group",
    charttype: "bar",
    numberfields: [],
    yvalues: [],//[]为数组
    xfields: [],
    xfield: null,//x轴默认为"item"为字符串
    timemodel: "month",
    chartval: '',


    //需要全局的值
    entrancehtml: "",

    //loading 状态 对应axios的请求和响应
    loading: false,

    //for aggregate page
    aggcollections: JSON.parse(localStorage.getItem('AGGCOLLECTIONS')) || [],

    //for theform receives
    // approvers: [],
    receivers: []
  },
  getters: {




    showchart: state => {
      return (
        // this.$store.chartswitch===true&&
        state.items.length > 0 &&
        state.ifchart &&
        state.chartdataxy.length > 0 &&
        // this.$store.state.clct &&
        state.xfield &&
        state.numberfields.length > 0 &&
        state.collection.value === state.clct
      )
    }


  },
  mutations: {
    // setapprovers(state, val) {
    //   state.approvers = val
    // },
    setreceivers(state, val) {
      state.receivers = val
    },
    //变换collection时，重设置参数
    reset(state) {

      //state.clct = "";
      console.log("reset")
      state.items = [];
      state.xfield = null;
      state.yvalues = [];
      state.timemodel = "month"
      state.chartmodel = "group"
      state.searchmodelthattime = ""
      this.commit("setsortset", {});
      this.commit("resetitems", "edits"); //清空store中的edits
      this.commit("resetitems", "editsid");
      this.commit("resetitems", "prints"); //清空store中的prints
      this.commit("resetitems", "printsid");
      this.commit("resetitems", "modifys"); //清空store中的modifys
      this.commit("resetitems", "modifysid");
      this.commit("resetitems", "qtyreduce"); //清空store中的qtyreduce
      this.commit("resetitems", "qtyincrease"); //清空store中的qtyincrease
      this.commit("setchartdatagroup", { labels: [], datas: [] });
      this.commit("setchartdatatime", []);
      this.commit("setunshowfields", { tag: 'show', fieldsset: { unshows: [] } })
      state.targettxt = "";
      state.datainformation = {};
      state.page = 1;
      state.filter = {};
      state.filtercode = {};
      state.qtyincrease = [];
      state.qtyincreaseid = [];
      state.qtyreduce = [];
      state.qtyreduceid = [];
      state.receivers = [];
      state.matchrule = {};
      state.unshowfields = {};
      state.fetchids = [];
    },

    // resetchart(state){

    // },
    // setsortset(state, x) {
    //   if (!x) {
    //     state.sortset = {}
    //   }
    //   else {
    //     switch (state.sortset[x.name]) {
    //       case undefined:
    //         Vue.set(state.sortset, x.name, 1)
    //         break;
    //       case 1:
    //         Vue.set(state.sortset, x.name, -1)

    //         break;
    //       case -1:
    //         Vue.delete(state.sortset, x.name)

    //         return;
    //     }
    //   }
    // },
    setsortset(state, obj) {
      state.sortset = obj
    },
    setaggcollections(state, val) {
      let aggcollections = val.slice(-4)
      //if(val.length<1){aggcollections=["guide"]}
      state.aggcollections = aggcollections//state.roles.includes("superadmin")?val:aggcollections
      localStorage.setItem("AGGCOLLECTIONS", JSON.stringify(aggcollections))
    },

    setmatchrule(state, obj) {
      // state.matchrulestatus = !state.matchrulestatus
      state.matchrule = obj
      // for (let key in obj) {
      //   if (obj[key] == "") {
      //     delete state.matchrule[key]
      //   }
      //   else { state.matchrule = Object.assign(state.matchrule, obj) }
      // }
    },

    setunshowfields(state, obj) {

      //unshowfields中只有shows，但是为了便于设置可以设置unshows，但是需要在此转换成shows
      if (obj.fieldsset && obj.fieldsset.unshows) {//&&obj.fieldsset.unshows.length>0
        let shows = []
        state.currentheader.forEach(fieldobj => {
          if (!obj.fieldsset.unshows.includes(fieldobj.name)) {
            shows.push(fieldobj.name)
          }
        })
        obj.fieldsset.shows = shows

      }
      // console.log(obj)
      state.unshowfields = obj
    },

    setfilter(state, obj) {
      // console.log(obj)
      state.filter = obj
    },
    setfilterbyval(state, keyval) {
      // console.log(obj)
      state.filter[keyval.key] = keyval.val
    },

    setfiltercode(state, obj) {
      // console.log(obj)
      state.filtercode = obj
    },
    setitems(state, arr) {
      state.items = arr
    },
    setdatainformation(state, obj) {
      state.datainformation = obj
    },
    settargettxt(state, val) {
      state.targettxt = val
    },
    setpage(state, val) { state.page = val },
    setsearchmodel(state, val) {
      state.searchmodel = val
    },



    setapiparams(state, obj) {
      state.apiparams = obj
    },

    //设置collections
    setcollections(state, arr) {
      state.collections = arr
    },

    setcollection(state, obj) {
      state.collection = obj
      localStorage.setItem("CLCT", obj.value)
      state.clct = obj.value


    },
    setcollectionbyval(state, val) {
      let objcollection = state.collections.find((obj) => {
        return obj.value === val;
      });

      if (objcollection == undefined) {
        objcollection = state.collections.find(obj => {
          return obj.value === "pictures";
        }) || state.collections[0]
      }

      localStorage.setItem("CLCT", objcollection.value)
      state.clct = objcollection.value
      state.collection = objcollection

    },




    setcurrentheader(state, arr) {

      state.timemodel = "month"
      state.chartmodel = "group"


      if (arr.length < 1) { arr = [{ name: 'placeholder', title: 'placeholder' }] }

      let xfields = [];
      let numberfields = []
      arr.forEach(obj => {
        if (
          obj.type != "numberrange" &&
          obj.type != "daterange" &&
          obj.visible != false &&
          obj.xvisible != false &&
          obj.filterable != "no"
        ) {
          xfields.push(obj)
        }
        //如果是数字，又在xvisible中指定了，那么显示
        if (obj.type === "numberrange" && obj.xvisible === false) {
          xfields.push(obj)
        }
        if (obj.type === "numberrange" && obj.visible != false && obj.yvisible != false) {

          numberfields.push(obj)
        }
      })



      let yvalues = numberfields
        .map(obj => {
          return obj.name;
        })

      state.currentheader = arr;
      state.xfields = xfields;
      state.numberfields = numberfields;

      if (!state.xfield) { state.xfield = xfields[0].name };
      if (state.yvalues.length<1) { state.yvalues = yvalues }


    },

    setfetchids(state, val) {
      state.fetchids = val
    },

    setfetchidstag(state, val) {
      state.fetchidstag = val
    },



    setsearchmodelthattime(state, val) {
      state.searchmodelthattime = val
    },

    setsplittarget(state, val) {
      state.splittarget = val
    },
    settheevalforsplit(state,val){
      state.theevalforsplit=val
    },
    setsplittimemodel(state,obj){
      // console.log("aaaaa")
      state.splittimemodel=obj
    },
    setsplituniques(state,val){
      state.splituniques=val
    },
    setsplitfixed(state, val) {
      state.splitfixed = val
    },
    setsumitem(state, val) {
      state.sumitem = val
    },
    seturlbeforesplit(state,val){
      state.urlbeforesplit=val
    },



    addsavedsearch(state, tag) {

      let newitem = {
        collection: state.collection.value,
        tag: tag,
        href: window.location.href
      }

      //如果存在tag，删除替换
      state.savedsearch.forEach((obj, i) => {
        if (obj.tag === newitem.tag) {
          delete state.savedsearch[i]
        }
      })

      state.savedsearch = state.savedsearch.filter(function (el) { return el != null; });
      state.savedsearch.push(newitem)

      localStorage.setItem("SAVEDSEARCH", JSON.stringify(state.savedsearch))
    },

    removesavedsearch(state, tag) {
      state.savedsearch = state.savedsearch.filter(obj => {
        return obj.tag != tag
      })
      localStorage.setItem("SAVEDSEARCH", JSON.stringify(state.savedsearch))
    },

    sethistory(state, history) {
      state.history = history
      localStorage.setItem("HISTORY", JSON.stringify(history))
    },
    setedits(state, obj) {
      state.edits.push(obj)
      if (obj._id) { state.editsid.push(obj._id) }
    },
    setprint(state, obj) {
      state.prints.push(obj)
      if (obj._id) { state.printsid.push(obj._id) }
    },
    setmodify(state, obj) {

      //如果已经存在那么移除，否则添加
      let index = state.modifysid.findIndex(e => { return e === obj._id })
      if (index > -1) {
        state.modifys.splice(index, 1)
        state.modifysid.splice(index, 1)
      }
      else {
        state.modifys.push(obj)
        if (obj._id) { state.modifysid.push(obj._id) }
      }
    },

    setvalue(state, obj) {
      state[obj.target][obj.index][obj.key] = obj.value
      state[obj.target].splice(0, 0)
    },
    resetitems(state, val) {
      state[val] = [];
      state[val + "id"] = []
    },
    removeitem(state, val) {
      state[val.where].splice(val.itemindex, 1)
      state[val.where + 'id'].splice(val.itemindex, 1)
    },
    setqtyincrease(state, val) {
      state.qtyincrease.push(val)
      state.qtyincreaseid.push(val._id)
    },
    setqtyreduce(state, val) {
      state.qtyreduce.push(val)
      state.qtyreduceid.push(val._id)
    },


    // setdbadminauthto(state,obj){
    //   localStorage.setItem("DBADMINAUTHTO", obj.dbadminauthto)
    //   state.dbadminauthto=obj.dbadminauthto
    // },
    //for authentication
    setToken(state, val) {
      localStorage.setItem('USER_TOKEN', val)
      state.token = val
    },
    setExpireTime(state, val) {
      localStorage.setItem('EXPIRE_TIME', val)
      state.expireTime = val
    },
    setUser(state, val) {
      localStorage.setItem('USER', val)
      state.user = val
    },
    setPermissions(state, val) {
      localStorage.setItem('PERMISSIONS', val)
      state.permissions = val
    },
    setWeight(state, val) {
      localStorage.setItem('USERWEIGHT', val)
      state.userweight = val
    },
    setUserRoles(state, val) {
      //userroles为user本身的roles
      localStorage.setItem('USERROLES', JSON.stringify(val))
      state.userroles = val
      localStorage.setItem('ROLES', JSON.stringify(val))
      //roles为动态的roles，在clctinitial中判断设置
      state.roles = val
    },

    setRoles(state, val) {
      localStorage.setItem('ROLES', JSON.stringify(val))
      state.roles = val
    },

    setCommunity(state, val) {
      localStorage.setItem('COMMUNITY', JSON.stringify(val))
      state.community = val
    },


    setentrancehtml(state, val) {
      state.entrancehtml = val
    },

    //设置loading状态
    setloading(state, val) {
      state.loading = val
    },
    //for presentation 
    process(state, status) {//from fetchdata
      state.dbprocessing = status
    },


    setifremotechart(state, val) {
      state.ifremotechart = val
    },
    setchartdatanomore(state, val) {
      state.chartdatanomore = val
    },
    setxfield(state, val) {
      state.xfield = val
    },
    settimemodel(state, val) {
      state.timemodel = val
    },
    setyvalues(state, val) {
      state.yvalues = val

    },

    setifchart(state) {
      state.ifchart = !state.ifchart
    },
    setchartval(state, val) {
      state.chartval = val
    },

    setcharttype(state, val) {
      state.charttype = val
      state.chartdatagroup.datas.splice(0, 0)
    },

    // setchartdata(state,{xy,group}){
    //   state.chartdatagroup = group
    //   state.chartdataxy = xy
    // },

    setchartmodel(state, val) {
      state.chartmodel = val
    },
    setchartdatagroup(state, val) {
      // state.chartmodel = "group"
      // state.chartdataxy = []
      state.chartdatagroup = val

      //state.dbprocessing=false
    },
    setchartdatatime(state, val) {
      state.chartdatatime = val
    },


    setchartdataxy(state, val) {
      // state.chartmodel = "time"
      // state.chartdatagroup = {}
      state.chartdataxy = val

      //state.dbprocessing=false
    },

    batchset(state, query) {
      for (let k in query) {
        state[k] = query[k]
      }
    }
  }
})


export default store


// WEBPACK FOOTER //
// ./src/store/index.js